import app, { Component } from 'apprun';
import { auth, companies as companyApi } from './api';

const search = (state, e) => ({ ...state, filter: e.target.value });

const Item = ({ item }) => (
  <tr class="hand" $onclick={['#company', item.id, item.name]}>
    <td>
      <a>{item.id}</a>
    </td>
    <td>
      <a>{item.name}</a>
    </td>
  </tr>
);

const List = ({ items }) => (
  <table class="table table-striped table-condensed table-bordered table-hover">
    <thead>
      <tr>
        <th>Id</th>
        <th>Name</th>
      </tr>
    </thead>
    <tbody>
      {items.map(item => <Item item={item} />)}
    </tbody>
  </table>
);

export default class CompanyListComponent extends Component {

  state = async () => {
    const createAllowed = await auth.hasPermission('CompanyCreate', 'C');
    const companies = await companyApi.getAllCompanies();
    return { companies, createAllowed };
  };

  view = (state) => {
    if (!state || !state.companies) { return; }
    const companies = !state.filter
      ? state.companies
      : state.companies.filter(c => (c.name.toUpperCase() + c.id.toString()).indexOf(state.filter.toUpperCase()) >= 0);

    return (
      <div style={{ width: '500px' }}>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Search..." $oninput={search} value={state.filter || ''} />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" $onclick={['#company', null, 'company [New]']} disabled={!state.createAllowed}> + </button>
          </span>
        </div>
        <List items={companies} />
      </div>
    );
  };

}
